import { render } from "./ListAuditableAssets.vue?vue&type=template&id=23d10b36&scoped=true"
import script from "./ListAuditableAssets.vue?vue&type=script&lang=js"
export * from "./ListAuditableAssets.vue?vue&type=script&lang=js"

import "./ListAuditableAssets.vue?vue&type=style&index=0&id=23d10b36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d10b36"]])

export default __exports__